import { ServerError, ServerParseError } from '@apollo/client';

export function isServerError(err: Error | ServerError | ServerParseError): err is ServerError {
  return err.name === 'ServerError';
}
